var React = require('react');

function Ap (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_522_629)","key":0},[React.createElement("path",{"d":"M89.4857 0H0V69H89.4857L120 33.12L89.4857 0Z","fill":"#C7D800","key":0}),React.createElement("path",{"d":"M30.4531 43.8359H19.1523L17.0039 50.2812H10.1504L21.7949 19H27.7676L39.4766 50.2812H32.623L30.4531 43.8359ZM20.8926 38.6152H28.7129L24.7812 26.9062L20.8926 38.6152Z","fill":"white","key":1}),React.createElement("path",{"d":"M40.4375 32.1562V29.5312H47.25V22.6719H49.9219V29.5312H56.7344V32.1562H49.9219V39H47.25V32.1562H40.4375Z","fill":"white","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_522_629"},React.createElement("rect",{"width":"120","height":"69","fill":"white"})))]);
}

Ap.defaultProps = {"width":"120","height":"69","viewBox":"0 0 120 69","fill":"none"};

module.exports = Ap;

Ap.default = Ap;
